import { EvaluatorContext, EvaluatorEvaluation } from "../Evaluator"
import { Experiment, ParameterConfiguration, Variation, VariationId, VariationKey } from "../../../model/model"
import ExperimentRequest from "./ExperimentRequest"
import ObjectUtil from "../../../util/ObjectUtil"

export default class ExperimentEvaluation implements EvaluatorEvaluation {
  constructor(
    readonly reason: string,
    readonly targetEvaluations: EvaluatorEvaluation[],
    readonly experiment: Experiment,
    readonly variationId: VariationId | undefined,
    readonly variationKey: VariationKey,
    readonly config: ParameterConfiguration | undefined
  ) {}

  with(reason: string): ExperimentEvaluation {
    return new ExperimentEvaluation(
      reason,
      this.targetEvaluations,
      this.experiment,
      this.variationId,
      this.variationKey,
      this.config
    )
  }

  static of(
    request: ExperimentRequest,
    context: EvaluatorContext,
    variation: Variation,
    reason: string
  ): ExperimentEvaluation {
    return new ExperimentEvaluation(
      reason,
      context.targetEvaluations,
      request.experiment,
      variation.id,
      variation.key,
      variation.config
    )
  }

  static ofDefault(request: ExperimentRequest, context: EvaluatorContext, reason: string): ExperimentEvaluation {
    const variation = request.experiment._getVariationByKeyOrNull(request.defaultVariationKey)
    if (ObjectUtil.isNotNullOrUndefined(variation)) {
      return this.of(request, context, variation, reason)
    } else {
      return new ExperimentEvaluation(
        reason,
        context.targetEvaluations,
        request.experiment,
        undefined,
        request.defaultVariationKey,
        undefined
      )
    }
  }
}
